import { ShipBuilder } from './ship-builder';
import { World } from '../model/world';
import { WorldGrid } from '../model/world-grid';

export class WorldBuilder {
  static build(gameGrid: WorldGrid): World {
    const shipBuilder = new ShipBuilder()
    const player = shipBuilder.player()
    const enemies = shipBuilder.enemies()

    return new World(gameGrid, player, enemies)
  }
}